// extracted by mini-css-extract-plugin
export default {"container":"BotThree_container__ODUPs"};